import { cn } from '@restworld/utils-common';
export function Separator() {
  return (
    <div className="flex flex-row items-center gap-3.75 w-full">
      <StyledLine />
      <span className="text-base text-black leading-none">o</span>
      <StyledLine />
    </div>
  );
}

const StyledLine = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div className={cn('flex flex-1 border-t border-gray-400', className)} {...props} />
);
